import React from 'react';
import { processSteps } from '../../data/mock';

const Process = () => {
  return (
    <section id="process" className="py-16 lg:py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Section header */}
        <div className="text-center mb-20">
          <p className="text-amber-800/80 text-base tracking-[0.2em] uppercase mb-4">
            Partnership Process
          </p>
          <h2 className="text-4xl md:text-5xl font-light text-stone-800 mb-6">
            パートナーシップまでの流れ
          </h2>
          <div className="w-20 h-px bg-amber-700/40 mx-auto" />
        </div>

        {/* Process steps */}
        <div className="relative">
          {/* Connection line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-px bg-stone-200 -translate-y-1/2" />
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((step, index) => (
              <div key={step.step} className="relative">
                <div className="bg-white p-8 rounded-2xl border border-stone-200 hover:border-amber-200 hover-lift card-gradient-accent h-full">
                  {/* Step number */}
                  <div className="w-14 h-14 rounded-full bg-gradient-to-br from-amber-100 to-stone-100 flex items-center justify-center mb-6 mx-auto lg:mx-0 relative z-10">
                    <span className="text-xl font-light text-stone-700">
                      {step.step}
                    </span>
                  </div>
                  
                  <h3 className="text-xl font-medium text-stone-800 mb-3 text-center lg:text-left">
                    {step.title}
                  </h3>
                  <p className="text-stone-500 font-light text-base leading-relaxed text-center lg:text-left">
                    {step.description}
                  </p>
                </div>
                
                {/* Arrow for desktop */}
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 w-8 h-8 -translate-y-1/2 z-20">
                    <div className="w-full h-full flex items-center justify-center">
                      <div className="w-2 h-2 rotate-45 border-t-2 border-r-2 border-amber-400" />
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;
